import Funcao, { FinderFuncoes, RetornoFuncao } from 'Interface/Funcoes';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { formData, paramsParaString } from '../utils';

const tag = 'Funcoes';

const url = '/funcoes';

const apiExtendida = api.enhanceEndpoints({
    addTagTypes: [tag],
}).injectEndpoints({
    endpoints: construtor => ({
        recuperarFuncoes: construtor.query<FinderFuncoes, Parametros | void>({
            query: (params) => `${url}?${paramsParaString(params)}`,
            providesTags: (resultado) => resultado?.funcoes
                ? [
                    ...resultado.funcoes.map(({ id }) => ({ type: tag, id } as const)),
                    { type: tag, id: 'LISTA' },
                ]
                : [{ type: tag, id: 'LISTA' }],
        }),
        recuperarFuncao: construtor.query<RetornoFuncao, string | number | Parametros>({
            query: params => {
                let id: number;
                let query: Parametros = {};

                if (['string', 'number'].includes(typeof params)) {
                    id = params as number;
                } else {
                    params = params as Parametros;

                    id = params.id as number;
                    query = paramsParaString(params);
                }

                return `${url}/${id}?${query}`;
            },
            providesTags: (resultado, erro, params) => {
                let id: number;

                if (['string', 'number'].includes(typeof params)) {
                    id = params as number;
                } else {
                    params = params as Parametros;

                    id = params.id as number;
                }

                return [{ type: tag, id }];
            },
        }),
        adicionarFuncao: construtor.mutation<RetornoFuncao, Partial<Funcao>>({
            query: (dados) => ({ url: url, method: 'POST', body: formData(dados, 'POST') }),
            invalidatesTags: (resultado, erro) => !erro ? [{ type: tag, id: 'LISTA' }] : [],
        }),
        editarFuncao: construtor.mutation<RetornoFuncao, Partial<Funcao> & Pick<Funcao, 'id'>>({
            query: ({ id, ...dados }) => ({ url: `${url}/${id}`, method: 'POST', body: formData(dados, 'PUT') }),
            invalidatesTags: (resultado, erro, { id }) => !erro ? [{ type: tag, id }] : [],
        }),
    }),
    overrideExisting: false,
});

export const {
    useRecuperarFuncoesQuery,
    useRecuperarFuncaoQuery,
    useAdicionarFuncaoMutation,
    useEditarFuncaoMutation,
} = apiExtendida;
